var _path, _path2, _path3, _path4, _path5, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CentralAfricanRepublicCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M6.697,14h34.605C37.843,8.028,31.398,4,24,4S10.157,8.028,6.697,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-3.647-0.992-7.056-2.697-10H6.697C4.992,16.944,4,20.353,4,24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M41.302,34C43.008,31.056,44,27.647,44,24H4c0,3.647,0.992,7.056,2.698,10H41.302z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M24,44c7.398,0,13.843-4.028,17.302-10H6.698C10.157,39.972,16.602,44,24,44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M32,42.325V5.675C29.549,4.604,26.846,4,24,4v40C26.846,44,29.549,43.396,32,42.325z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "17.535,11.351 19.618,13 18.88,10.309 20.964,8.662 18.425,8.662 17.535,6.123 16.778,8.662 14.088,8.662 16.342,10.309 15.432,13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CentralAfricanRepublicCircular);
export default __webpack_public_path__ + "static/media/icons8-central-african-republic-circular.7e1caf4543eea87ab32a8b8cf8787965.svg";
export { ForwardRef as ReactComponent };